import React, { cloneElement, isValidElement, useContext } from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { SkeletonBlock } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { SpecificationGroupContent } from './SpecificationGroupContent';
import { dataModel } from '../dataModel';

export const SingleProductSpecificationsComponent = (props) => {
  const {
    itemId,
    children,
    oneColumn,
    returnableStatus,
    isWhiteSpecTitle,
  } = props;
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const { data, loading } = useDataModel('product', { skip: !itemId, variables: { itemId } });

  if (loading) {
    return (
      <div
        className="sui-w-full"
        data-component="SingleSpecificationsPlaceholder"
      >
        <SkeletonBlock aspect="wide" height={52} width="100%" />
      </div>
    );
  }
  if (!data || !data?.product?.specificationGroup) {
    return null;
  }

  const { specificationGroup } = data.product;

  return (
    <div
      className="sui-flex sui-flex-wrap sui-w-full sui-box-border
      sui-pointer-events-auto sui-gap-6"
      id="specifications"
      data-component="SpecificationsAccordionBody"
    >
      {children && cloneElement(children, {
        itemId,
        maxfeatures: 8,
        minfeatures: isMobile ? 4 : 3,
        channel,
        displaySimilarLinks: true
      })}
      <SpecificationGroupContent
        specificationGroup={specificationGroup}
        oneColumn={oneColumn}
        returnableStatus={returnableStatus}
        isWhiteSpecTitle={isWhiteSpecTitle}
      />
    </div>
  );
};

SingleProductSpecificationsComponent.displayName = 'SingleProductSpecificationsComponent';
SingleProductSpecificationsComponent.dataModel = dataModel;

const propTypes = {
  itemId: PropTypes.string.isRequired,
  returnableStatus: PropTypes.bool,
  /** Can take an (optional) single child component of type KeyProductFeatures */
  children: (props, propName, componentName) => {
    const prop = props[propName];
    let error;
    if (prop && (!isValidElement(prop) || prop.type.name !== 'KeyProductFeatures')) {
      error = new Error(`'${componentName}' only accepts a single child of type 'KeyProductFeatures'`);
    }
    return error;
  },
  oneColumn: PropTypes.bool,
  isWhiteSpecTitle: PropTypes.bool,
};

const defaultProps = {
  children: null,
  oneColumn: false,
  returnableStatus: false,
  isWhiteSpecTitle: false,
};

SingleProductSpecificationsComponent.propTypes = propTypes;
SingleProductSpecificationsComponent.defaultProps = defaultProps;

export const SingleProductSpecifications = withErrorBoundary(SingleProductSpecificationsComponent);

SingleProductSpecifications.dataModel = dataModel;
SingleProductSpecifications.propTypes = propTypes;
SingleProductSpecifications.defaultProps = defaultProps;
